import AddIcon from '@mui/icons-material/Add';
import ClearAllIcon from '@mui/icons-material/ClearAll'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import RestoreIcon from '@mui/icons-material/Restore'
import SearchIcon from '@mui/icons-material/Search'
import { Autocomplete, Box, Breadcrumbs, Button, Card, Grid, IconButton, Link, Menu, MenuItem, Paper, TextField, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import * as XLSX from "xlsx";
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useForm } from 'react-hook-form'
import { useCSVReader } from 'react-papaparse'
import { useDispatch, useSelector } from 'react-redux'
import { useStyles } from '../../theme/theme'

import LoadingUI from '../../comman/LoadingUI'
import NoDataFound from '../../comman/NoDataFound'
import SnackBarUI from '../../comman/SnackBarUI'
import Appbar from '../../components/Appbar'
// import Drawer from '../../components/Drawer'
import { dateConvert } from '../../helper/dateConverter'
import Body from '../../layout/Body'

import { getSingleQuestionAnswerAction } from '../../redux/toolkit/question-answer/getSingleQuestionAnswer'
import { useLocation, useNavigate } from 'react-router-dom';
import { addAiGeneratedQuestionAction } from '../../redux/toolkit/question-answer/addAiGeneratedQuesi.js';

const breadcrumb = (
    <Stack>
        <Breadcrumbs separator={<NavigateNextIcon sx={{ color: '#5E6C8A' }} fontSize="small" />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: "#5E6C8A" }} color='inherit' href='/'>Home</Link>
            <Link underline="hover" sx={{ color: "#5E6C8A" }} color='inherit' href='/aiQuestions'>AI Generated Question</Link>
        </Breadcrumbs>
        <Typography sx={{ color: "#5E6C8A" }} variant='h4'>All AI Generated Question</Typography>
    </Stack>
)

let cat_id = ''

const AllAiQuestion = () => {
    const classes = useStyles();
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [selectedIds, setSelectedIds] = useState([]);
    const [pageSize, setPageSize] = useState(25);
    const [snack, setSnack] = useState(false);
    const [open, setOpen] = useState(false);

    const [rows, setRows] = useState([]);





    const addQuestionData = useSelector(state => state.aiGeneratedQuestionData)
    const { data: addAddData, message, status } = addQuestionData

    const qnsAns = useSelector(state => state.aiGeneratedQuestion);
    const { data, loading: qnsLoading, message: aimessage, status: aiStatus } = qnsAns;
    const [selectedRows, setSelectedRows] = useState([]);
    const { categoryId, categoryName, subCategoryId, subCategoryName } = location.state || {};




    // let cleanData = data;
    // if (typeof data === 'string') {
    //     cleanData = data
    //         .replace(/```json\s*/, '')  // remove starting ```json
    //         .replace(/```$/, '')        // remove ending ```
    //         .trim();

    //     try {
    //         // setOpen(true)
    //         cleanData = JSON.parse(cleanData);
    //     } catch (err) {
    //         cleanData = [];
    //     }
    // }
    // const jsonData = Array.isArray(cleanData) ? cleanData : [];

    // let rows = jsonData?.map((item, index) => ({
    //     _id: index + 1,
    //     cat_id: { cat_name: categoryName, _id: categoryId },
    //     sub_cat_id: { sub_cat_name: subCategoryName, _id: subCategoryId },
    //     ...item
    // }));




    const qnsDataGridColumns = [
        {
            field: 's_no',
            headerName: 'S. No.',
            filterable: false,
            flex: 1,
            minWidth: 50,
            headerClassName: 'super-app-theme--header',
            renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
        },
        // {
        //     field: '_id',
        //     headerName: 'ID',
        //     flex: 1,
        //     minWidth: 250,
        //     headerClassName: 'super-app-theme--header',
        // },
        {
            field: 'question',
            headerName: 'Question',
            flex: 1,
            minWidth: 200,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'options',
            headerName: 'Answer Options',
            flex: 1,
            minWidth: 200,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <ul>
                        {params.row.options.map(option => (
                            <li key={option._id} style={{ color: option.correct === true ? 'green' : 'black' }}>
                                {option.option}
                            </li>
                        ))}
                    </ul>

                )
            },
        },
        // {
        //   field: 'cat_id',
        //   headerName: 'Category Name',
        //   flex: 1,
        //   minWidth: 150,
        //   headerClassName: 'super-app-theme--header',
        //   renderCell: (params) => {
        //     return (
        //       <Typography>{params?.row?.cat_id?.cat_name}</Typography>
        //     )
        //   },
        // },
        // {
        //   field: 'link',
        //   headerName: 'Linked',
        //   flex: 1,
        //   minWidth: 150,
        //   headerClassName: 'super-app-theme--header',
        //   renderCell: (params) => {
        //     return (
        //       <>
        //         {params?.row?.link ? <CheckIcon color='success' /> : <ClearIcon color='error' />}
        //       </>
        //     )
        //   },
        // },
        {
            field: 'cat_id',
            headerName: 'Category Name',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.cat_id?.cat_name}</Typography>
                )
            },
        },
        {
            field: 'sub_cat_id',
            headerName: 'Sub Category Name',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.sub_cat_id?.sub_cat_name}</Typography>
                )
            },
        },

        // {
        //     field: 'answer_type',
        //     headerName: 'Answer Type',
        //     flex: 1,
        //     minWidth: 150,
        //     headerClassName: 'super-app-theme--header'
        // },

        {
            field: 'difficulty',
            headerName: 'Difficulty',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.difficulty ? params?.row?.difficulty : "---"}</Typography>
                )
            },
        },
        // {
        //     field: 'type',
        //     headerName: 'Question Type',
        //     flex: 1,
        //     minWidth: 150,
        //     headerClassName: 'super-app-theme--header'
        // },
        // {
        //     field: 'edit', headerName: 'Edit Q & A',
        //     renderCell: (params) => {
        //         return (
        //             <IconButton onClick={() => {
        //                 // setUpdateQns(true);
        //                 // dispatch(getSingleQuestionAnswerAction(params?.row?._id))
        //             }}><EditIcon color='primary' />
        //             </IconButton>
        //         )
        //     },
        //     flex: 1,
        //     minWidth: 150,
        //     headerClassName: 'super-app-theme--header',
        //     // hide: ativeFilter
        // },

        // {
        //     field: 'delete', headerName: 'Delete Q & A', renderCell: () => {
        //         return (
        //             <IconButton
        //                 onClick={(params) => {
        //                     // setDelQns(true)
        //                     // setqns_id(params?.row?._id)
        //                 }}>
        //                 <DeleteIcon color='error' /></IconButton>
        //         )
        //     },
        //     flex: 1,
        //     minWidth: 150,
        //     headerClassName: 'super-app-theme--header',
        //     // hide: ativeFilter || (!can_delete && super_admin != 'super_admin') 

        // },

        // {
        //     field: 'revert',
        //     headerName: 'Revert Questions',
        //     renderCell: () => {
        //         return (
        //             <IconButton
        //                 onClick={() => {
        //                     // setRestoreCat(true);
        //                 }}><RestoreIcon color='success' /></IconButton>
        //         )
        //     },
        //     flex: 1,
        //     minWidth: 150,
        //     headerClassName: 'super-app-theme--header',
        //     // hide: !ativeFilter
        // },

        // {
        //     field: 'created_at',
        //     headerName: 'Created_at',
        //     flex: 1,
        //     minWidth: 210,
        //     headerClassName: 'super-app-theme--header'
        // },
    ]


    const handleSelectionChange = (newSelection) => {
        // const selectedRowsData = rows.filter((row) => newSelection.includes(row._id));

        const selectedRowsData = rows
            .filter((row) => newSelection.includes(row._id))
            .map((row) => ({
                cat_id: row.cat_id,
                difficulty: row.difficulty,
                question: row.question,
                title: row?.title,
                options: row?.options,
                sub_cat_id: row?.sub_cat_id
            }));

        setSelectedIds(newSelection);
        setSelectedRows(selectedRowsData);
    };

    const AddMultipleHandler = () => {
        // setDelMulQns(true)
        console.log("selectedIds", selectedIds);
        dispatch(addAiGeneratedQuestionAction({ selectedQuestion: selectedRows, isDelete: true }))
        setSnack(true);

        setTimeout(() => {
            // window.location.reload();
            navigate("/qns-ans")
        }, 1000);

    }



    useEffect(() => {
        if (!data) return;

        let cleanData = data;

        if (typeof data === "string") {
            cleanData = data
                .replace(/```json\s*/, "")
                .replace(/```$/, "")       
                .trim();

            try {
                cleanData = JSON.parse(cleanData);
            } catch (err) {
                console.error("❌ JSON Parse Error:", err);
                cleanData = [];
            }
        }

        const jsonData = Array.isArray(cleanData) ? cleanData : [];
        
        const formattedRows = jsonData.map((item, index) => ({
            _id: index + 1,
            cat_id: { cat_name: categoryName, _id: categoryId },
            sub_cat_id: { sub_cat_name: subCategoryName, _id: subCategoryId },
            ...item,
        }));

       
        setRows(formattedRows);

    }, [data]);


    return (
        <>
            <Helmet><title> Quiz Wall | Question</title></Helmet>
            <Appbar breadcrumb={breadcrumb} />
            {/* <Drawer /> */}
            <Body>
                <Button variant="contained" disabled={selectedIds?.length === 0 ? true : false} onClick={() => AddMultipleHandler()}>Add Selected Q&A</Button>

                <Card sx={{ my: 2 }}>
                    <Paper sx={{
                        bgcolor: '#fff',
                        '& .super-app-theme--header': {
                            bgcolor: '#071D45',
                            color: '#fff',
                        },
                    }} elevation={0}>
                        <DataGrid
                            className={classes.root}
                            getRowHeight={() => 'auto'}
                            sx={{ border: 0 }}
                            rows={rows}
                            autoHeight
                            columns={qnsDataGridColumns}
                            getRowId={(row) => row._id}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            pagination
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[25, 50, 100]}
                            disableColumnSelector
                            loading={qnsLoading ? <LoadingUI /> : false}
                            onCellClick={(params) => {
                                // setqns_id(params?.row?._id)
                            }}
                            checkboxSelection
                            onSelectionModelChange={handleSelectionChange}
                            components={{
                                NoRowsOverlay: () => <NoDataFound />,
                                Toolbar: GridToolbar,
                            }}
                        />
                    </Paper>
                </Card>

            </Body>


            {snack && <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />}

            {open && <SnackBarUI state={open} setState={setOpen} status={aimessage} message={aiStatus} />}

        </>

    )
}

export default AllAiQuestion